import { useState, useLayoutEffect } from 'react';

const useWindowSize = (): number[] => {
  // Local states
  const [size, setSize] = useState([window.innerWidth, window.innerHeight]);

  // When window size changes
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return size;
};

export { useWindowSize };
